import React from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import { LayoutDashboard, Package, BarChart2, TrendingUp, LogOut, School } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';

const NAV = [
  { to: '/dashboard',   icon: <LayoutDashboard size={17} />, label: 'Dashboard'        },
  { to: '/orders',      icon: <Package size={17} />,         label: 'Orders'           },
  { to: '/redemption',  icon: <BarChart2 size={17} />,       label: 'Redemption Report'},
  { to: '/adoption',    icon: <TrendingUp size={17} />,      label: 'Adoption Trends'  },
];

export default function AppShell() {
  const { user, logout } = useAuth();
  const navigate         = useNavigate();

  const handleLogout = () => {
    logout();
    toast.success('Logged out');
    navigate('/login', { replace: true });
  };

  const initials = user?.name?.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'S';

  return (
    <div className="app-shell">
      <Toaster position="top-right" toastOptions={{ style: { fontFamily: 'DM Sans, sans-serif', fontSize: '13px', borderRadius: '8px' }, success: { iconTheme: { primary: '#C84B0F', secondary: '#fff' } } }} />

      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">S</div>
          <div className="sidebar-logo-text">Swardhara<span>School Portal</span></div>
        </div>

        {/* School chip */}
        {user?.school_name && (
          <div style={{ padding: '10px 14px', margin: '10px 12px 0', background: '#FEF3EE', borderRadius: 10, display: 'flex', alignItems: 'center', gap: 7 }}>
            <School size={14} color="#C84B0F" />
            <div style={{ fontSize: 12, fontWeight: 600, color: '#C84B0F', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user.school_name}</div>
          </div>
        )}

        <nav style={{ flex: 1, padding: '8px 0' }}>
          <div className="sidebar-section-label">Menu</div>
          {NAV.map(item => (
            <NavLink key={item.to} to={item.to}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* User footer */}
        <div style={{ padding: '12px 14px', borderTop: '1px solid #F0DCC8', display: 'flex', alignItems: 'center', gap: 9 }}>
          <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#FEF3EE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800, color: '#C84B0F', flexShrink: 0 }}>{initials}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.name}</div>
            <div style={{ fontSize: 10, color: '#9CA3AF' }}>School User</div>
          </div>
          <button onClick={handleLogout} title="Logout"
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9CA3AF', display: 'flex', padding: 2 }}>
            <LogOut size={15} />
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="main-content">
        <div className="topbar">
          <div style={{ flex: 1, fontSize: 14, fontWeight: 600, color: '#374151' }}>
            {user?.school_name || 'School Portal'}
          </div>
        </div>
        <div className="page-body">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
